import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';

interface Props {
  editorialStatus: string;
  onChange: (editorialStatus: string) => void;
  checkPermission: CheckPermissionFunction;
  validation: ValidationResult;
  label: string;
}

export function EditorialStatus(props: Props): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <LabelledDropdown
      id={'editorial_status'}
      value={props.editorialStatus || null}
      options={getVocabularyOptions(intl.locale, 'editorial_status_list', '*')}
      permissions={props.checkPermission()}
      validation={props.validation}
      onChange={(status: string): void => props.onChange(status)}
      title={props.label}
    />
  );
}
